import './index.css';
import { jsx, Fragment } from 'react/jsx-runtime';
import { memo } from 'react';

const PureChildren = memo(({ children }) => jsx(Fragment, { children: children }));
PureChildren.displayName = 'PureChildren';

export { PureChildren };
//# sourceMappingURL=PureChildren.js.map
